import React from 'react';
import PropTypes from 'prop-types';

const MessageBanner = ({ message }) => (
  <div className="message-banner text-align__center font-body">
    <p className="message-banner--text">{message}</p>
  </div>
);

MessageBanner.propTypes = {
  message: PropTypes.string.isRequired,
};

export default MessageBanner;



// WEBPACK FOOTER //
// src/components/atoms/MessageBanner/index.jsx